export default "__VITE_ASSET__eYdR6SA6__"